import React, { useRef } from "react";
import Header from "../../../Common/Header";
import { Card, Button, Breadcrumb, Affix, Form } from "antd";
import { isMobileView } from "../../../Common/AppHelper";
import { Link, useNavigate } from "react-router-dom";
import AddExportSalesContractForm from "./AddExportSalesContractForm";

export default function AddIou(props) {
  const { permitInfo, width } = props;
  const propertyFormRef = useRef(null);
  const [form] = Form.useForm();

  const navigate = useNavigate();
  const discartForm = () => {
    // propertyFormRef.current.discart();
    navigate("/export/sales-contract");
  };

  const addIou = () => {
    // propertyFormRef.current.submit();
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add Sales Contract / Master LC"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Affix offsetTop={20}>
                <Button
                  size="large"
                  key={1}
                  danger
                  onClick={() => discartForm()}
                >
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button
                  size="large"
                  key={2}
                  type="primary"
                  onClick={() => addIou()}
                >
                  Save
                </Button>
              </Affix>,
            ]}
          ></Header>
        </Card>
      </Affix>
      <AddExportSalesContractForm ref={propertyFormRef} form={form} />
    </>
  );
}
